<div class="app-container" style="height: 100%;"> <!--class="app-container" [ngClass]="{ 'bg-light': user }"-->
    <alert></alert>
    <router-outlet></router-outlet>
</div>